import { Injectable } from "@angular/core";
import { HttpHelperService } from "@services/http-helper.service";
import { Observable } from "rxjs";

import type { CIMasterPolicy } from "./certificate-of-insurance.state";

interface CIServiceResponse<T> {
  data?: T;
}

interface CIAgentListData {
  agentList: unknown[];
}

interface CIProductListData {
  productList: unknown[];
}

export interface CIReportQuery {
  userId: string;
  branchCode: string;
  agentCode: string;
  startDate: string;
  endDate: string;
  productType: string;
  productCode: string;
  cnoteType: string;
  type: string;
}

@Injectable()
export class CIService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getAgentList(
    userId: string,
  ): Observable<CIServiceResponse<CIAgentListData>> {
    return this.httpHelperService.get(`/common/agents?userId=${userId}`);
  }

  public getProductList(
    userId: string,
  ): Observable<CIServiceResponse<CIProductListData>> {
    return this.httpHelperService.get(`/common/lov/products?userId=${userId}`);
  }

  public getMasterPolicyList(
    agentCode: string,
    productCode: string,
  ): Observable<CIMasterPolicy[] | null> {
    return this.httpHelperService.get(
      `/cn/masterPolicy/details?agentCode=${agentCode}&productCode=${productCode}`,
    );
  }

  public downloadCITemplate(
    fileName: string,
    productType: string,
  ): Window | null {
    return window.open(
      this.httpHelperService.getURLString(
        `/download/ci/upload/template?fileName=${fileName}&productType=${productType}`,
      ),
    );
  }

  public uploadCiInfo(): string {
    return this.httpHelperService.postXmlRequest(`/cn/ci/upload`);
  }

  public getCIReport(payload: CIReportQuery): Window | null {
    const {
      userId,
      branchCode,
      agentCode,
      startDate,
      endDate,
      productType,
      productCode,
      cnoteType: _cnoteType,
      type,
    } = payload;
    let url = `/report/ci/download?`;
    url += userId ? `userId=${userId}` : "";
    url += branchCode ? `&branchCode=${branchCode}` : "";
    url += agentCode ? `&agentCode=${agentCode}` : "";
    url += startDate ? `&startDate=${startDate}` : "";
    url += endDate ? `&endDate=${endDate}` : "";
    url += productType ? `&productType=${productType}` : "";
    url += productCode ? `&productCode=${productCode}` : "";
    url += type ? `&type=${type}` : "";

    return window.open(this.httpHelperService.getURLString(url));
  }
}
